<div class="blotter">
  <div class="blotter-header">
    <label class="widget-title">ÓRDENES DEL DÍA</label>
    <img
      alt="Refrescar"
      src="/images/b-input-refrescar.svg"
      class="refresh"
      (mouseover)="showRefreshTooltip = true"
      (mouseleave)="showRefreshTooltip = false"
      (click)="refresh()"
      [class.disabled]="refreshIsDisabled"
    />
    <hb-tooltip-component
      *ngIf="showRefreshTooltip"
      [text]="'Refresh'"
      [relativePosition]="'top'"
      [width]="70"
    >
    </hb-tooltip-component>
  </div>

  <ul class="tabs square">
    <li [class.selected]="selectedTab === 0" (click)="changeView(0)">
      Capitales
    </li>
    <li
      [class.selected]="selectedTab === 1"
      (click)="changeView(1)"
      *ngIf="!isUsaContract"
    >
      Fondos
    </li>
    <li
      [class.selected]="selectedTab === 2"
      (click)="changeView(2)"
      *ngIf="isUserGlobal === false"
    >
      Efectivo
    </li>
  </ul>
  <hb-blotter-capitals
    *ngIf="selectedTab === 0"
    [isInPortfolio]="false"
    [showDownloadExcel]="standardUser === true"
    [isRefreshing]="isRefreshing"
  >
  </hb-blotter-capitals>
  <hb-blotter-funds
    *ngIf="selectedTab === 1"
    [showDownloadExcel]="standardUser === true"
    [isRefreshing]="isRefreshing"
  >
  </hb-blotter-funds>
  <hb-blotter-cash
    *ngIf="selectedTab === 2 && isUserGlobal === false"
    [showDownloadExcel]="standardUser === true"
    [isRefreshing]="isRefreshing"
  >
  </hb-blotter-cash>
</div>
